import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import SolutionSection from './SolutionSection';
import ROICalculator from './ROICalculator';
import HowItWorks from './HowItWorks';
import PricingSection from './PricingSection';
import TrustSection from './TrustSection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';
import Navbar from './Navbar';
import Footer from './Footer';
import ContactModal from './ContactModal';
import { useLocation } from 'react-router-dom';

const LandingPage = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const elementId = hash.substring(1);
      setTimeout(() => {
        document.getElementById(elementId)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gradient-dark">
      <Navbar />
      
      <HeroSection />
      
      <ProblemSection />
      
      <SolutionSection />
      
      <ROICalculator />
      
      <HowItWorks />
      
      <PricingSection />
      
      <TrustSection />
      
      <FAQSection />
      
      <CTASection />
      
      <Footer onOpenContact={() => setShowContactModal(true)} />

      {showContactModal && (
        <ContactModal onClose={() => setShowContactModal(false)} />
      )}
    </div>
  );
};

export default LandingPage;
